// extracted by mini-css-extract-plugin
module.exports = {"row":"_3AsRw","col":"YVyDP","gallery":"_2e9ZF","price":"_2xFBC","sku":"_2lYt5","options":"_1WshO"};